// react.js
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Col,
  FormGroup,
  Label,
  Input,
  Row,
  Button,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

const ModalRegPost = ({ isOpen, toggle }) => {
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState({
    nombre_post: "",
    apellido_post: "",
    email_post: "",
    ci_bec_post: "",
    cel_bec_post: "",
  });

  const validation = {
    nombre_post: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    apellido_post: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    ci_bec_post: { regex: /^\d{6,12}$/, isValid: true },
    cel_bec_post: { regex: /^\d{8}$/, isValid: true },
    email_post: {
      regex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      isValid: false,
    },
  };

  const [isValid, setIsValid] = useState({
    nombre_post: false,
    apellido_post: false,
    email_post: false,
    cel_bec_post: false,
    ci_bec_post: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuarioSeleccionado((prev) => ({ ...prev, [name]: value }));
    const isValidValue = validation[name].regex.test(value);
    setIsValid((prev) => ({ ...prev, [name]: isValidValue }));
  };

  // Alertas
  const mostrarAlertaError = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Error!",
      text: "No se pudo registrar.",
      timer: 5000,
      icon: "error",
    });
  };
  const mostrarAlertaErrorPDF = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Error!",
      text: "Por favor, selecciona un archivo PDF válido.",
      timer: 5000,
      icon: "error",
    });
  };

  const mostrarAlertaC = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Registro exitoso.",
      timer: 5000,
      icon: "success",
    });
  };
  const [isEnabledPDF, setIsEnabledPDF] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [archivoPDF, setArchivoPDF] = useState(null);
  const [archivoOtro, setArchivoOtro] = useState(null);

  // Para PDF
  const handleFileChangePDF = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      if (file.type === "application/pdf") {
        setArchivoPDF(file);
        setIsEnabledPDF(true);
      } else {
        mostrarAlertaErrorPDF();
        setArchivoPDF(null);
        setIsEnabledPDF(false);
      }
    } else {
      setArchivoPDF(null);
      setIsEnabledPDF(false);
    }
  };

  // Para otros archivos
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setArchivoOtro(e.target.files[0]);
      setIsEnabled(true);
    } else {
      setArchivoOtro(null);
      setIsEnabled(false);
    }
  };

  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";

  const handleSubmit = async () => {
    if (!archivoPDF) {
      alert("Debe seleccionar un documento PDF válido antes de guardar.");
      return;
    }
    try {
      if (!archivoPDF || !archivoOtro) {
        alert("Por favor, selecciona ambos archivos antes de guardar.");
        return;
      }

      const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve(reader.result.split(",")[1]);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      const base64PDF = await fileToBase64(archivoPDF);
      const base64Otro = await fileToBase64(archivoOtro);

      const data = {
        ...usuarioSeleccionado,
        archivo_pdf: base64PDF,
        archivo_otro: base64Otro,
      };

      const res = await axios.post(`${baseUrl}?action=addPostReg`, data, {
        headers: { "Content-Type": "application/json" },
      });

      if (res.data.msg) {
        mostrarAlertaC();
        // Limpieza
        setUsuarioSeleccionado({
          nombre_post: "",
          apellido_post: "",
          email_post: "",
          ci_bec_post: "",
          cel_bec_post: "",
        });
        setArchivoPDF(null);
        setArchivoOtro(null);
        toggle();
      } else {
        mostrarAlertaError();
      }
    } catch (error) {
      console.error("Error en la petición:", error);
      mostrarAlertaError();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader className="header_mo" toggle={toggle}>
        Postulación a la Beca
      </ModalHeader>
      <ModalBody>
        <Form>
          {/* Campos */}
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Nombres:</Label>
                <Input
                  type="text"
                  name="nombre_post"
                  value={usuarioSeleccionado.nombre_post}
                  onChange={handleChange}
                />
                {!isValid.nombre_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Apellidos:</Label>
                <Input
                  type="text"
                  name="apellido_post"
                  value={usuarioSeleccionado.apellido_post}
                  onChange={handleChange}
                />
                {!isValid.apellido_post && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
            </Col>
          </Row>
          {/* Otros campos */}
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label>Correo:</Label>
                <Input
                  type="text"
                  name="email_post"
                  value={usuarioSeleccionado.email_post}
                  onChange={handleChange}
                />
                {!isValid.email_post && (
                  <span style={{ color: "red" }}>Correo no válido</span>
                )}
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Carnet de Identidad:</Label>
                <Input
                  type="number"
                  name="ci_bec_post"
                  value={usuarioSeleccionado.ci_bec_post}
                  onChange={handleChange}
                />
                {!isValid.ci_bec_post && (
                  <span style={{ color: "red" }}>Formato no válido</span>
                )}
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Celular:</Label>
                <Input
                  type="text"
                  name="cel_bec_post"
                  value={usuarioSeleccionado.cel_bec_post}
                  onChange={handleChange}
                />
                {!isValid.cel_bec_post && (
                  <span style={{ color: "red" }}>Número celular no válido</span>
                )}
              </FormGroup>
            </Col>
          </Row>
          {/* Archivo */}
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Documentos:</Label>
                <Label tag="h6" className="text-danger">
                  <strong>Requisitos en PDF:</strong>
                </Label>
                <Input
                  type="file"
                  accept="application/pdf"
                  onChange={handleFileChangePDF}
                />

                <Label tag="h6" className="text-success">
                  <strong>Formulario en Excel:</strong>
                </Label>
                <Input
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={handleFileChange}
                />
              </FormGroup>
            </Col>
          </Row>
          {/* Botón */}
          <Button
            color="success"
            size="lg"
            onClick={handleSubmit}
            disabled={
              !isValid.nombre_post ||
              !isValid.apellido_post ||
              !isValid.ci_bec_post ||
              !isValid.email_post ||
              !isValid.cel_bec_post ||
              !isEnabled ||
              !isEnabledPDF
            }
          >
            Guardar y Cargar
          </Button>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ModalRegPost;
